import { render, staticRenderFns } from "./ScadaEventList.vue?vue&type=template&id=4c876c0c&"
import script from "./ScadaEventList.vue?vue&type=script&lang=js&"
export * from "./ScadaEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports